import { BaseEntity } from "./BaseEntity";

export class UserEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.users.usersList.PageTitle";
        this.pageTitle = "components.settings.index.userManagement";
        this.menuPath = "/settings";
        this.APIRoute = "Resources/Settings/Users"
        this.i18nBase = "components.users.userList";
        this.baseEndPoint = "user";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            activate: `${this.baseEndPoint}/:id/activate`,
            deactivate: `${this.baseEndPoint}/:id/deactivate`,
            reset2FA: `${this.baseEndPoint}/:id/reset2FA`,
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "hidden",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                label: "components.myProfile.accountDetails.fullName",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "email",
                label: "components.users.userCreate.email",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "email"
            },
            {
                key: "login",
                label: "components.myProfile.accountDetails.username",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                readOnly: true,
                cols: 6,
                path: "login"
            },
            {
                key: "permissions",
                label: "components.users.userCreate.permissionGroup",
                type: "autocomplete",
                visible: true,
                editable: true,
                cols: 6,
                searchHandler: "handleSearchPermission",
                options: [],
                path: "permissions",
                multiple: true
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "email",
                label: "components.users.userCreate.email",
                width: "145px",
                smallScreenWidth: "100px",
                smallScreenMaxChars: 24,
                visible: true,
                orderBy: true
            },
            {
                key: "last_access",
                label: "common.labels.lastAccess",
                width: "145px",
                smallScreenWidth: "100px",
                smallScreenMaxChars: 24,
                visible: true,
                orderBy: false
            },
            {
                key: "status",
                label:  "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.pages = {
            edit: {
                pageTitle: `components.users.userCreate.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings/components.settings.index.userManagement`,
                route: ["/settings","/settings/users", "/settings/user/edit/:id"]
            },
            create: {
                pageTitle: `components.users.userCreate.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings/components.settings.index.userManagement`,
                route: ["/settings","/settings/users", "/settings/user/create"]
            },
            list: {
                pageTitle: `components.settings.index.userManagement`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings`,
                route: ["/settings/users"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "email",
                                type: "text",
                                label:  "components.users.userCreate.email",
                            },
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            }
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
